<template>
    <router-view />
</template>

<script>
export default {
    name: "Licence",
};
</script>

<style lang="scss" scoped></style>
